module.exports = __webpack_public_path__ + "static/media/structure.18153955.png";